import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { ExportType, ReportMenu } from '../../../constants'
import { authService, reportService } from '../../../services'
import { exportFile, formatter } from '../../../util'

// UI
import { Button, List, Page, Pager } from '../../../components'
import notify from '../../../components/Notification'
import Skeleton from 'antd/lib/skeleton'
import Icon from 'antd/lib/icon'
import Spin from 'antd/lib/spin'
import Tooltip from 'antd/lib/tooltip'

import './styles.css'
import { connect } from 'react-redux'
import { settingOtherService } from '../../../services/setting'
import { Form, Input } from 'antd';
const { Item: FormItem } = Form
const pageSize = 50

export class ReportEmployeeFile extends Component {
  constructor (props) {
    super(props)
    this.state = {
      expiredList: { list: [], total: 0 },
      expiringList: { list: [], total: 0 },
      currentPage: 1,
      isLoaded: false,
      loading: false,
      loadingExport: false,
      loadingList: false,
      settings: {},
    }
  }

  componentDidMount () {
    this.fetchList()
    this.fetchOtherSettings()
  }

  render () {
    const { currentPage, loading, loadingExport, loadingList, expiredList, expiringList, total, settings } = this.state
    const { form } = this.props
    const { getFieldDecorator } = form
    const longFormItemLayout = {
      labelCol: { sm: 6, md: 6, lg: 4 },
      wrapperCol: { sm: 10, md: 10, lg: 14 }
    }

    const endedColumns = [
      {
        title: 'Employee',
        width: 8,
        render: ({ id, employee }) => <a href={`/employees/${id}`} rel='noopener noreferrer' target='_blank'>{employee}</a>
      },
      {
        title: 'Files',
        width: 10,
        render: ({ files }) => files.map((item, idx) => {
          return (
            <div>● {`${item.main_category} - ${item.sub_category}`}</div>
          )
        })
      },
      {
        title: 'Expiry Date',
        width: 3,
        render: ({ files }) => files.map((item, idx) => {
          return (
            <div>{formatter.toShortDate(item.expiry_date)}</div>
          )
        })
      },
      {
        title: 'As of Today',
        width: 3,
        render: ({ files }) => files.map((item, idx) => {
          return (
            <div>{`${formatter.getDaysAgo(formatter.expiringDuration(item.expiry_date))}`}</div>
          )
        })
      }
    ]

    const endingColumns = [
      {
        title: 'Employee',
        width: 8,
        render: ({ id, employee }) => <a href={`/employees/${id}`} rel='noopener noreferrer' target='_blank'>{employee}</a>
      },
      {
        title: 'Files',
        width: 10,
        render: ({ files }) => files.map((item, idx) => {
          return (
            <div>● {`${item.main_category} - ${item.sub_category}`}</div>
          )
        })
      },
      {
        title: 'Expiry Date',
        width: 3,
        render: ({ files }) => files.map((item, idx) => {
          return (
            <div>{formatter.toShortDate(item.expiry_date)}</div>
          )
        })
      },
      {
        title: 'As of Today',
        width: 3,
        render: ({ files }) => files.map((item, idx) => {
          return (
            <div>{`${formatter.getDaysToGo(formatter.expiringDuration(item.expiry_date))}`}</div>
          )
        })
      }
    ]


    return (
      <Page.Body>
        <Page.Left>
          <Page.Menu title='Home' menu={ReportMenu} />
        </Page.Left>

        <Page.Content full>
          <Page.Header title={`Employee's Files`} >
            { !loading
              ? <Button key={'export'} feedback={loadingExport} onClick={() => this.handleExport()}>
                Export
              </Button>
              : null }
            { !loading
              ? this.hasAccess('listRecipients') 
              ? this.hasAccess('updateRecipient') ?
              <Button ghost key={'save'} feedback={loadingExport} onClick={() => this.handleSave()}>
                Save
              </Button> : null : null
              : null }

          </Page.Header>

          <div className='admin-list'>
            { !loading
              ? this.hasAccess('listRecipients') 
              ? <Form {...longFormItemLayout}>
                   <FormItem label="Weekly Email Recipients">
                          {getFieldDecorator('employee_file_email', {
                          initialValue: settings.employee_file_email,
                          rules: [{ required: true, message: 'Please enter weekly email report recipients' }]
                            })
                          (<Input />)
                          }
                   </FormItem>
                 </Form> : null
              : null }   
          </div>

          <div className='admin-list'>
            <Skeleton loading={loading} active>
              <div className='report-title'>{`Employees with Expired Files `} <span className='report-tag'>{expiredList.total}</span></div>
              <List cols={endedColumns} rows={expiredList.list} />

              <div className='report-title'>{`Employees with Expiring Files `} <span className='report-tag'>{expiringList.total}</span></div>
              <List cols={endingColumns} rows={expiringList.list} />
            </Skeleton>
          </div>
        </Page.Content>
      </Page.Body>
    )
  }

  fetchList () {
    const { currentPage, isLoaded, loading } = this.state
    this.fetchEmpFile({currentPage, isLoaded, loading})
  }

  async fetchEmpFile ({ currentPage, isLoaded = true, loading }) {
    if (this.hasAccess('readEmployeeCertReport')) {
      if (isLoaded) {
        this.setState({ loadingList: true })
      } else {
        this.setState({ loading: true })
      }

      try {
        const { expiring, expired } = await reportService.getListByAll(ExportType.REPORT.EMPLOYEE_FILE)

        this.setState({
          expiringList: expiring,
          expiredList: expired,
          loading: false,
          loadingList: false,
          isLoaded: true
        }, () => this.toTop())
      } catch (e) {
        notify.error('Unable to get Employee Files Report', 'Please try again later.')
        this.setState({ loading: false, loadingList: false, isLoaded: false  })
      }
    }
  }

  fetchOtherSettings = async () => {
    try {
      this.setState({ loading: true })
      const settings = await settingOtherService.listByPage(1, 0)

      this.setState({ settings: settings.list[0], loading: false })
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load settings successfully. Please try again later.')
    }
  }

  handleSave = () => {
    const { form } = this.props
    const { settings } = this.state
    const { validateFields } = form

    validateFields(async (errors, values) => {
      if (!errors) {
        const { id } = settings
        this.setState({ loadingForm: true })

        try {
          let response = await settingOtherService.save(id, values)

          this.setState({ loadingForm: false })
          
          if (response.id) {
            notify.success('Saved successfully', `Settings saved successfully.`)
          } else {
            notify.error('Unable to save successfully', `Unable to save settings successfully. Please try again later.`)
          }
        } catch (e) {
          notify.error('Unable to save successfully', `Unable to save settings successfully. Please try again later.`)
          this.setState({ loadingForm: false })
        }
      }
    })
  }

  onChangePage (page) {
    this.setState({ currentPage: page }, () => {
      this.fetchList()
    })
  }

  handleExport = () => {
    const { loadingExport, loading, loadingList } = this.state

    if (loadingExport || loading || loadingList || !this.hasAccess('readEmployeeCertReport')) return

    this.setState({ loadingExport: true })

    setTimeout(async () => {
      const r = await exportFile.fetchReportExport(ExportType.REPORT.EMPLOYEE_FILE)
      this.setState({ loadingExport: false })
    }, 4000)
  }

  hasAccess (accessLevel) {
    return authService.hasAccess(accessLevel)
  }

  toTop () {
    if(window) {
      window.scrollTo(0, 0)
    }
  }
}

const mapDispatchToProps = {
}

const mapStateToProps = (state) => {
  return state
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(ReportEmployeeFile))

